(function () {
  'use strict';

  function keepOneSubscription() {
    document.querySelectorAll('.subscriptions_app_embed_block').forEach((el) => {
      el.style.display = 'none';
    });
    document.querySelectorAll('.shopify_subscriptions_app_block').forEach((el, i) => {
      el.style.display = i === 0 ? '' : 'none';
    });
  }
  keepOneSubscription();
  setTimeout(keepOneSubscription, 800);
  setTimeout(keepOneSubscription, 2000);

  // Flavour showcase
  const sc = document.querySelector('[data-showcase]');
  if (sc) {
    const readFlavors = () =>
      [...sc.querySelectorAll('.sc-data')].map((d) => ({
        no: d.querySelector('.d-no')?.textContent || '',
        name: d.querySelector('.d-name')?.innerHTML || '',
        note: d.querySelector('.d-note')?.textContent || '',
        url: d.querySelector('.d-url')?.textContent || '',
        price: d.querySelector('.d-price')?.textContent || ''
      }));
    let FLAVORS = readFlavors();
    const slides = [...sc.querySelectorAll('[data-flavor-slide]')];
    const no = sc.querySelector('[data-sc-no]');
    const nm = sc.querySelector('[data-sc-name]');
    const nt = sc.querySelector('[data-sc-note]');
    const cta = sc.querySelector('[data-sc-cta]');
    const tabs = [...sc.querySelectorAll('.sc-tab')];
    let cur = 0;
    let timer;

    const setText = (f) => {
      if (no) no.textContent = f.no;
      if (nm) nm.innerHTML = f.name;
      if (nt) nt.textContent = f.note;
      if (cta && f.url) {
        cta.href = f.url;
        if (f.price) cta.textContent = cta.textContent.replace(/·.*/, '') + ' · ' + f.price;
      }
    };

    if (FLAVORS[0]) setText(FLAVORS[0]);

    const go = (i) => {
      if (i === cur || !FLAVORS[i]) return;
      cur = i;
      const f = FLAVORS[i];
      sc.classList.toggle('pinked', i === 1);
      slides.forEach((s, j) => s.classList.toggle('on', j === i));
      const inc = slides[i];
      if (inc) {
        inc.classList.remove('slosh');
        void inc.offsetWidth;
        inc.classList.add('slosh');
        setTimeout(() => inc.classList.remove('slosh'), 1600);
      }
      [no, nm, nt].forEach((el) => el && el.classList.add('out'));
      setTimeout(() => {
        setText(f);
        [no, nm, nt].forEach((el) => el && el.classList.remove('out'));
      }, 400);
      tabs.forEach((tb, j) => {
        tb.classList.toggle('on', j === i);
        tb.setAttribute('aria-selected', j === i ? 'true' : 'false');
      });
    };

    tabs.forEach((tb) =>
      tb.addEventListener('click', () => {
        go(+tb.dataset.f);
        restart();
      })
    );

    const auto = () => go((cur + 1) % FLAVORS.length);
    const restart = () => {
      clearInterval(timer);
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(auto, 6500);
    };
    restart();
    sc.addEventListener('pointerenter', () => clearInterval(timer));
    sc.addEventListener('pointerleave', restart);

    const tilt = sc.querySelector('.tilt');
    if (tilt && matchMedia('(pointer:fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sc.addEventListener('mousemove', (e) => {
        const r = sc.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        tilt.style.transform = `perspective(1100px) rotateY(${(x * 14).toFixed(2)}deg) rotateX(${(-y * 10).toFixed(2)}deg)`;
      });
      sc.addEventListener('mouseleave', () => {
        tilt.style.transform = 'perspective(1100px)';
      });
    }
  }

  // Split headings
  document.querySelectorAll('.split').forEach((h) => {
    const walk = (n) => {
      [...n.childNodes].forEach((c) => {
        if (c.nodeType === 3 && c.textContent.trim()) {
          const frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach((w) => {
            if (/^\s+$/.test(w) || w === '') frag.appendChild(document.createTextNode(w));
            else {
              const s = document.createElement('span');
              s.className = 'w';
              s.textContent = w;
              frag.appendChild(s);
            }
          });
          n.replaceChild(frag, c);
        } else if (c.nodeType === 1) walk(c);
      });
    };
    walk(h);
    h.querySelectorAll('.w').forEach((s, i) => s.style.setProperty('--i', i));
  });

  const observeIn = (sel, threshold = 0.12) => {
    const io = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        }),
      { threshold }
    );
    document.querySelectorAll(sel).forEach((el) => io.observe(el));
  };
  observeIn('.rv');
  observeIn('.split,.table,.cases,.places', 0.3);
  document.querySelectorAll('.places li').forEach((li, i) => li.style.setProperty('--i', i));

  // Hero parallax
  const hi = document.querySelector('.hero-img');
  const bg1 = document.querySelector('.blob.g');
  const bg2 = document.querySelector('.blob.p');
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    addEventListener(
      'scroll',
      () => {
        const y = scrollY;
        if (y < innerHeight) {
          if (hi) hi.style.transform = `translateY(${y * 0.1}px)`;
          if (bg1) bg1.style.translate = `0 ${y * 0.18}px`;
          if (bg2) bg2.style.translate = `0 ${y * -0.12}px`;
        }
      },
      { passive: true }
    );
  }

  // Nav light over dark sections
  const nav = document.querySelector('[data-nav]');
  const panel = document.querySelector('[data-nav-panel]');
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const setSolid = () => {
    if (!nav) return;
    const homeHero = document.querySelector('.hero');
    const solid = !homeHero || window.scrollY > 12 || window.innerWidth <= 820;
    nav.classList.toggle('solid', solid);
  };
  setSolid();
  addEventListener('scroll', setSolid, { passive: true });
  addEventListener('resize', setSolid);

  function setMenu(open) {
    if (!panel || !menuBtn) return;
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);
  }
  menuBtn?.addEventListener('click', () => setMenu(!panel.classList.contains('is-open')));
  panel?.querySelectorAll('[data-menu-close], a').forEach((el) => el.addEventListener('click', () => setMenu(false)));

  if (nav) {
    const nio = new IntersectionObserver(
      (es) => es.forEach((e) => nav.classList.toggle('light', e.isIntersecting)),
      { rootMargin: '-40px 0px -95% 0px' }
    );
    document.querySelectorAll('[data-nav="light"]').forEach((s) => nio.observe(s));
  }

  // PDP plan picker UI + qty
  document.querySelectorAll('[data-product-section]').forEach((root) => {
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const basePrice = priceEl ? priceEl.textContent : '';

    root.querySelectorAll('.plan-opt').forEach((opt) => {
      const input = opt.querySelector('input[data-selling-plan]');
      if (!input) return;
      input.addEventListener('change', () => {
        root.querySelectorAll('.plan-opt').forEach((o) => o.classList.remove('is-on'));
        opt.classList.add('is-on');
        if (input.dataset.planPrice && priceEl) {
          const cents = parseInt(input.dataset.planPrice, 10);
          priceEl.textContent = formatMoney(cents);
          if (compareEl && input.dataset.comparePrice) {
            compareEl.textContent = formatMoney(parseInt(input.dataset.comparePrice, 10));
            compareEl.hidden = false;
          }
        } else if (priceEl) {
          priceEl.textContent = basePrice;
          if (compareEl) compareEl.hidden = true;
        }
      });
    });

    const qty = root.querySelector('[data-qty-input]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      if (qty) qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1);
    });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      if (qty) qty.value = parseInt(qty.value || '1', 10) + 1;
    });
  });

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.Suvena?.moneyFormat || '{{amount}}');
    }
    return (cents / 100).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
  }

  const searchPop = document.querySelector('[data-search-pop]');
  const searchInput = document.getElementById('HeaderSearch');
  function setSearch(open) {
    if (!searchPop) return;
    searchPop.hidden = !open;
    document.querySelector('[data-search-open]')?.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) searchInput?.focus();
  }
  document.querySelector('[data-search-open]')?.addEventListener('click', (e) => {
    e.preventDefault();
    setSearch(searchPop?.hidden !== false);
  });
  document.querySelector('[data-search-close]')?.addEventListener('click', () => setSearch(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      setSearch(false);
      setMenu(false);
    }
  });

})();
